const axios = require("axios");
const axiosRetry = require("axios-retry")
const { SecretsManagerClient, GetSecretValueCommand } = require('@aws-sdk/client-secrets-manager')

const { BaseClient } = require("../../shared");

class JavelinaBaseClient extends BaseClient {
    constructor(
        javelinaProxyApiUrl = process.env.JAVELINA_PROXY_API_URL, 
        javelinaProxySecretName = process.env.JAVELINA_PROXY_SECRET_NAME || '',
        axiosOptions
    ) {
        super(javelinaProxyApiUrl, javelinaProxySecretName, axiosOptions)
    }

    async createSecureAxiosInstance(customHeaders = {}) {
        // Checking if the instance exists with the same headers and content type
        if (
            this.secureAxiosInstance && 
            JSON.stringify(this.secureCustomHeaders) === JSON.stringify(customHeaders)
        ) {
            return
        }

        if (!this.secretName)
            throw new Error("'secretName' must be defined")

        const secretsManagerClient = new SecretsManagerClient()

        const { SecretString } = await secretsManagerClient.send(new GetSecretValueCommand({ SecretId: this.secretName }));

        const secretObject = JSON.parse(SecretString)

        this.secureCustomHeaders = customHeaders

        this.secureAxiosInstance = axios.create({
            baseURL: this.url,
            headers: {
                connection: "keep-alive",
                "content-type": "application/json",
                "x-api-key": secretObject.accessToken,
                ...customHeaders
            }
        });
    }

    loadConstants() {
        return require('./constants.json')
    }

    createAxiosInstance(customHeaders = {}) {
        // Checking if the instance exists with the same headers and content type
        if (
            this.axiosInstance && 
            JSON.stringify(this.customHeaders) === JSON.stringify(customHeaders)
        ) {
            return
        }

        this.customHeaders = customHeaders

        this.axiosInstance = axios.create({
            baseURL: this.url,
            headers: {
                connection: "keep-alive",
                "content-type": "application/json",
                ...customHeaders
            }
        });
    }

    async createAxiosRetryInstance(customHeaders = {}) {
        // Checking if the instance exists with the same headers and content type
        if (
            this.axiosRetryInstance && 
            JSON.stringify(this.retryCustomHeaders) === JSON.stringify(customHeaders)
        ) {
            return
        }

        if (!this.secretName)
            throw new Error("'secretName' must be defined")

        const secretsManagerClient = new SecretsManagerClient()

        const { SecretString } = await secretsManagerClient.send(new GetSecretValueCommand({ SecretId: this.secretName }));

        const secretObject = JSON.parse(SecretString)

        this.retryCustomHeaders = customHeaders

        this.axiosRetryInstance = axios.create({
            baseURL: this.url,
            headers: {
                "content-type": "application/json",
                "x-api-key": secretObject.accessToken,
                ...customHeaders
            }
        });

        axiosRetry(this.axiosRetryInstance, {
            retries: 5,
            retryCondition: (error) => error && error.response && error.response.status === 500,
        });
    }

    /**
     * @param {*} params 
     * @param {*} path 
     */
    queryParamsToPathParams(params, path) {
        if (params != null) {
            for (let key of Object.keys(params)) {
                if (params[key]) {
                    path += `/${key}/${params[key]}`
                }
            }
        }
        
        return path;
    }

    async loopPaginationResults(key, response) {
        await this.createSecureAxiosInstance()

        let results = [];
        if (response == null || response.Response == null || response.Response[key] == null ||
            response.Response[key].length < 1) {
            return results;
        }
    
        results.push(...response.Response[key]);

        if (response.Response.Pagination != null && response.Response.Pagination.Next != null) {
            const splitNextArray = response.Response.Pagination.Next.split('/');
            const indexOfRest = splitNextArray.indexOf('rest') + 1;
            let path = `pureProxy`;

            for (let i = indexOfRest; i < splitNextArray.length; i++) {
                path += `/${splitNextArray[i]}`;
            }
    
            const newResponse = await this.secureAxiosInstance.get(path);

            if (newResponse.status !== 200) {
                return null;
            }

            response = newResponse.data;
            results.push(...(await this.loopPaginationResults(key, response)));
        }

        return results;
    }
}

module.exports = JavelinaBaseClient
